module.exports = __webpack_public_path__ + "calendario.6b2cb8af5d24aeefbf414abf2cd51750.jpg";